import classNames from "classnames";
import { useNavigationToggle } from "../../../../contexts/NavigationContext";
import Icon from "../../../atoms/Icon";
import styles from "./styles.scss";

const NaviMenuToggleButton = () => {
  const { isNavigationOpen, toggleNavigation } = useNavigationToggle();

  return (
    <button
      className={classNames(styles.root, { [styles.opened]: isNavigationOpen })}
      onClick={toggleNavigation}
    >
      <div className={styles.iconWrapper}>
        <Icon name="icon-arrow-open" className={styles.iconOpen} />
        <Icon name="icon-arrow-close" className={styles.iconClose} />
      </div>
      <div className={styles.label}>閉じる</div>
    </button>
  );
};

export default NaviMenuToggleButton;
